import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useTranslation } from 'next-i18next';
import { Modal } from '@components/common/Modal/Modal';
import { Button } from '@components/common/Forms';

/**
 * @description Modal shown when a user reaches the application limit (HTTP 420).
 *
 * - Open from anywhere: `showApplicationLimitModal()`
 */
export const ApplicationLimitModal = NiceModal.create(() => {
  const modal = useModal();
  const { t } = useTranslation('common');

  const closeModal = () => {
    void modal.hide();
  };

  return (
    <Modal
      isOpen={modal.visible}
      onClose={closeModal}
      size="sm"
      header={t('application_limit.modal.title')}
      body={(
        <div className="flex flex-col gap-6 p-6">
          <p className="text-sm text-ink-medium">
            {t('application_limit.modal.description')}
          </p>
          <Button
            styling="solid"
            color="promo"
            size="lg"
            rounding="2xl"
            onClick={closeModal}
          >
            {t('application_limit.modal.activate_cta')}
          </Button>
        </div>
      )}
    />
  );
});

export const showApplicationLimitModal = () => {
  void NiceModal.show(ApplicationLimitModal);
};
